import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FieldConfig } from "src/app/shared/models/field-config.model";

@Component({
  selector: "app-dialog-change-name-field",
  templateUrl: "./dialog-change-name-field.component.html",
  styleUrls: ["./dialog-change-name-field.component.scss"],
})
export class DialogChangeNameFieldComponent implements OnInit {

  public nameField: FormControl = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<DialogChangeNameFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dataNameField: FieldConfig[] }
  ) {}

  ngOnInit() {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  changeNameField() {
    if(this.nameField.value) {
      this.dialogRef.close(this.nameField.value);
    }
  }
}
